import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "swiper/css";
import "swiper/css/autoplay";
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
// import background2 from "../../src/images/homepage/banner/b2.jpg";
// import background3 from "../../src/images/homepage/banner/b3.jpg";
// import background1 from "../../src/images/homepage/banner/bannerh.png";

// const banners = [
//   {
//     image: background1,
//     title: "Put your confidence in our ",
//     title2: "Pre-Delivery Inspection ",
//     title3: "(PDI) Services.",
//     description:
//       "Our expert PDI ensures your vehicle meets top safety and quality standards, protecting your investment with expert precision.",
//     buttonText: "Book PDI",
//   },
//   {
//     image: background2,
//     title: "Expose Hidden Issues in  ",
//     title2:"Pre-Owned Cars",
//     title3:"and Buy Confidently",
//     description:
//       " Our certified pre-owned car assessment uncovers hidden issues, ensures a clear understanding of the vehicle’s condition, and protects your investment and safety.",
//     buttonText: "Learn More",
//     secondButtonText: "Sign Up", // Added second button for the second slide
//   },

//   {
//     image: background3,
//     title: "Drive Safe and Confident with ",
//     title2:"Pre-Trip Inspections",
//     description:
//       "A pre-trip car inspection ensures your vehicle is in top condition, preventing breakdowns and costly repairs. At CarvetPro, we check key components like tires, brakes, and fluids so you can drive confidently, prioritizing safety and reliability.",
//     buttonText: "Learn More",
//     secondButtonText: "Log In", // Added second button for the second slide
//   },
// ];

const BannerNew = ({ slides }) => {
  const navigate = useNavigate();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  // Handlers for navigation
  const handleBookPDI = () => {
    if (!isAuthenticated) {
      navigate("/login"); // Redirect to login if not authenticated
    } else {
      navigate("/service"); // Navigate to service page if authenticated
    }
  };

  const handleLogin = () => {
    navigate("/login"); // Navigate to login page
  };

  const handleSignup = () => {
    navigate("/signup"); // Navigate to sign-up page
  };

  return (
    <section className="w-full h-screen ">
    <Swiper
      modules={[Autoplay]}
      autoplay={{
        delay: 3000,
        disableOnInteraction: false,
      }}
      loop={true}
      speed={1000}
      slidesPerView={1}
      spaceBetween={0}
      effect="fade"
      fadeEffect={{ crossFade: true }}
      className="h-screen"
    >
      {slides.map((banner, index) => (
        <SwiperSlide key={banner.id || index}>
          <div
            className="relative h-screen w-full"
            style={{
              backgroundImage: `url(${banner.image?.url})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="text-center mx-4 sm:mx-8 md:mx-12">
                {banner.titleLine1 && (
                  <h2 className="text-white text-4xl max-w-[450px] leading-tight">
                    {banner.titleLine1}
                  </h2>
                )}
                {banner.titleLine2 && (
                  <h2 className="text-[#FFBD6F] text-4xl max-w-[450px] leading-tight">
                    {banner.titleLine2}
                  </h2>
                )}
                {banner.titleLine3 && (
                  <h2 className="text-white text-4xl max-w-[450px] leading-tight">
                    {banner.titleLine3}
                  </h2>
                )}

                {banner.description && (
                  <p className="text-white text-md max-w-[500px] mt-4">
                    {banner.description}
                  </p>
                )}

                {banner.primaryButtonText && (
                  <button
                    onClick={handleBookPDI}
                    className="text-[#F0FFC5] text-md font-semibold py-4 px-12 mt-5 bg-[#060C0A] rounded-full shadow-inner-custom
                      transition-all duration-300 ease-in-out transform hover:scale-105 hover:bg-gradient-to-b hover:from-[#060C0A] hover:to-[#4c5b207c] active:scale-95 active:translate-y-1"
                  >
                    {banner.primaryButtonText}
                  </button>
                )}

                {/* Second button shown only if not authenticated and second text exists */}
                {!isAuthenticated && banner.secondaryButtonText && (
                  <button
                    onClick={
                      banner.secondaryButtonText === "Log In"
                        ? handleLogin
                        : handleSignup
                    }
                    className="text-[#F0FFC5] lg:ml-5 text-md font-semibold py-3 px-14 mt-5 bg-transparent border-2 border-[#ADD143] rounded-full
                      transition-all duration-300 ease-in-out transform hover:scale-105 hover:bg-[#71892986] hover:border-[#9BC133] active:scale-95 active:translate-y-1"
                  >
                    {banner.secondaryButtonText}
                  </button>
                )}
              </div>
            </div>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
    </section>
  );
};

export default BannerNew;
